// src/RouterProvider.js
import React, { createContext, useCallback, useContext, useState } from 'react';

// Create the Router Context
const RouterContext = createContext({

});

// Custom hook to use the Router Context
export const useRouter = () => useContext(RouterContext);

// Provider component to wrap the app and manage screen state
export const RouterProvider = ({ children }) => {
  const [currentScreen, setCurrentScreen] = useState('home'); // Default screen is 'home'

  const navigate = useCallback((screen) => {
    setCurrentScreen(screen);
  }, []);

  return (
    <RouterContext.Provider value={{ currentScreen, navigate }}>
      {children}
    </RouterContext.Provider>
  );
};
